import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents-list-icon" }
const _hoisted_3 = { class: "contents-list-icon-main" }
const _hoisted_4 = { class: "notice-list" }
const _hoisted_5 = ["onClick"]

import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { processing, processend } from "@/utils/view";
import { Home } from "@/models/home";
import { NoticeList } from "@/models/notice/noticeList";
import { useStore } from "vuex";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import CommonMessage from "@/views/base/CommonMessage.vue";
import Pagination from "@/views/base/Pagination.vue";

// ---- Types -------------------------------------------------
type Notices = {
  articleId: string;
  title: string;
  dateFirstPublished: string;
  isRead: boolean;
};

// ---- Variable ----------------------------------------------
const componentId = "generalpurpose03-01";
const menuId = "notifications";

export default /*@__PURE__*/_defineComponent({
  __name: 'NoticeList',
  setup(__props) {

let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing();
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend();
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.href = "/cms/login";
    }
  },
});

// セッションエラーチェック
let sessionErr = ref(false);

// ---- Constant ----------------------------------------------
const router = useRouter();
const store = useStore();
const noticeListModel = new NoticeList({});
// お知らせデータを格納するリアクティブなリスト
const noticeList = ref<Notices[]>([]);

// ----- Function ---------------------------------------------
// お知らせ取得 ページネーション設定
let props = reactive({
  cond: { status: 0 }, // APIの検索条件
  page: 1, // 表示するページ番号（省略時は1）
  size: 20, // 表示件数20件
  getTotalCount: (): Promise<number> => {
    return noticeListModel.getTotalCount();
  },
  getPageData: (page: number, size: number): Promise<any> => {
    return noticeListModel.getPageData(page, size);
  },
});

// 一覧データ取得
const notify = (result: any) => {
  if (!result.isSuccess) {
    const decodedMessage = decodeURIComponent(
      result.data.error?.response?.data?.message
    );
    const status = result.data.error?.response?.status;
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialog.open(decodedMessage);
    return;
  } else {
    noticeList.value = result.data;
    window.scrollTo({ top: 0 });
  }
};

// お知らせ詳細に遷移（コンテンツ記事詳細画面）
const goToNotice = (noticeId: string) => {
  router.push({
    name: "notice/detail",
    params: {
      articleId: noticeId,
    },
  });
};

const fetchHasNewNotification = async () => {
  const home = new Home();
  await home.hasNewNotice().then(([model, _response, err]) => {
    if (err) {
      // エラー
      const status = err.error?.response?.status;
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      // セッションエラー
      if (status === 408) sessionErr.value = true;
      errorDialog.open(decodedMessage);
      return;
    }
    store.commit("setHasNewNotification", _response.data?.hasNewNotice);
  });
};

onMounted(async () => {
  fetchHasNewNotification();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, { activeMenu: menuId }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("notice_list_title")), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contents-list-icon-tri" }, null, -1))
          ]),
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value, (notice) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "notice-item",
                key: notice.articleId
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["notice-item-date", { 'is-new': !notice.isRead }])
                }, _toDisplayString(notice.dateFirstPublished), 3),
                _createElementVNode("div", {
                  class: "notice-item-title",
                  onClick: ($event: any) => (goToNotice(notice.articleId))
                }, _toDisplayString(notice.title), 9, _hoisted_5)
              ]))
            }), 128))
          ]),
          _createVNode(Pagination, _mergeProps(_unref(props), { onNotify: notify }), null, 16)
        ]),
        _createVNode(Footer, { "scroll-target": componentId })
      ])
    ]),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(CommonMessage, _mergeProps({ key: 0 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})